import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CountTo from 'vue-count-to';
import { dealersCount } from '@/api/dealers';
import { getAgentBranchWiseCount } from '@/api/agents';
import { productCount } from '@/api/products';
import { ordersTicketsCount } from '@/api/orders-tickets';
import { getQuery } from '@/utils/index';
import { AdminModule } from '@/store/modules/admin';
import Inr from '@/components/Inr/index.vue';
import { isExcludedToAccess, isAdmin, isSuperAdmin, isInvoiceManager } from '@/common';
import { topSellingProducts, topDealers, totalOutstanding, totalCollection, totalFySales, totalFyPayment, totalCurrentRecievable, totalPendingOrders, getOverdueByDays } from '@/api/dashboard';
import { BranchAgentService } from '@/services/branch-agent-service';
import { getPendingPaymentLedgerCount } from '@/api/ledgers';
import { getRangeWiseReports } from '@/api/orders-products-dispatches';
import { getRanges } from '@/api/ranges';
import { getTotalStockValue } from '@/api/reports';
import moment from 'moment';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.supportTicketCount = [];
    this.items = [{
      value: 'Sales Report'
    }, {
      value: 'Item Wise Report'
    }, {
      value: 'Item Wise Report New'
    }, {
      value: 'Outstanding Ageing Report'
    }, {
      value: 'Payments Report'
    }, {
      value: 'Range Wise Report'
    }, {
      value: 'Average Report'
    }, {
      value: 'Ledgers'
    }, {
      value: 'Admins'
    }, {
      value: 'Dealers'
    }, {
      value: 'Products'
    }, {
      value: 'Ranges'
    }, {
      value: 'Branches'
    }, {
      value: 'Agents'
    }, {
      value: 'Orders'
    }, {
      value: 'Dispatches'
    }];
    this.dealerCount = 0;
    this.agentCount = 0;
    this.productscount = 0;
    this.orderscount = 0;
    this.totalOutstandingAmount = 0;
    this.totalStockValue = 0;
    this.totalPendingLedgers = 0;
    this.totalAmountReceived = 0;
    this.totalFySales = 0;
    this.totalFyPayment = 0;
    this.currentRecievableAmount = 0;
    this.totalPendingOrders = 0;
    this.currentMonthSales = 0;
    this.currentMonthPayments = 0;
    this.previousMonthSales = 0;
    this.previousMonthPayments = 0;
    this.topProducts = [];
    this.topDealers = [];
    this.dateRange = '';
    this.superAdmin = false;
    this.isAgent = false;
    this.agentId = undefined;
    this.currentDateRange = '';
    this.overdueAmount30days = 0;
    this.overdueAmount60days = 0;
    this.overdueAmount90days = 0;
    this.overdueAmount120days = 0;
    this.currentMonthDate = '';
    this.currentFinancialYearDate = '';
    this.previousMonthDate = '';
    this.branchListLoading = false;
    this.branchList = [];
    this.branchId = null;
    this.assignedBranches = [] || null;
    this.applyBranchIdFilter = true;
    this.excludeBranches = false;
    this.totalAdvanceAmount = 0;
    this.rangeList = [];
    this.rangeTotals = {};
    this.query = '';
  }
  // private isAllowed() {
  //   return !isRegionalManager() && !isSalesExecutiveManager();
  // }
  async activated() {
    try {
      if (AdminModule.roles.includes('Super Admin')) {
        this.superAdmin = true;
      }
      if (AdminModule.userType === 'Agent') {
        this.isAgent = true;
        this.agentId = AdminModule.agentId;
      }
      if (AdminModule.branchIds.length === 0) {
        throw new Error('You are not assigned to a branch.');
      }
      // Assign branchId using BranchAgentService
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.excludeBranches = true;
      this.currentMonthDate = {
        start: this.$moment().startOf('month').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().endOf('month').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.currentFinancialYearDate = {
        start: this.$moment().month(this.$moment().month() < 3 ? 3 : 3).date(1).subtract(this.$moment().month() < 3 ? 1 : 0, 'year').startOf('day').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().month(2).date(31).add(this.$moment().month() < 3 ? 0 : 1, 'year').endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.previousMonthDate = {
        start: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.currentDateRange = {
        start: this.$moment().startOf('day').format('YYYY-MM-DD hh:mm') + ' am',
        end: this.$moment().endOf('day').format('YYYY-MM-DD hh:mm') + ' pm'
      };
      this.getAllTilesData();
      // this.getSupportTicketCount();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
    }
  }
  searchSuggestions(query, callback) {
    // Filter the items array to find matches
    const results = this.items.filter(item => item.value.toLowerCase().includes(query.toLowerCase()));
    const limitedResults = results.slice(0, 5);
    callback(limitedResults); // Return filtered results
  }
  handleSelect(item) {
    this.query = item.value; // Set the input value to the selected item
    if (item.value === 'Sales Report') {
      this.$router.push('/report/salesReport/list');
      this.query = '';
    }
    if (item.value === 'Sales Report') {
      this.$router.push('/report/salesReport/list');
      this.query = '';
    }
    if (item.value === 'Item Wise Report') {
      this.$router.push('/report/itemWiseReport/list');
      this.query = '';
    }
    if (item.value === 'Item Wise Report New') {
      this.$router.push('/report/newItemWiseReport/list');
      this.query = '';
    }
    if (item.value === 'Outstanding Ageing Report') {
      this.$router.push('/report/dealerWiseOsOdReport/list');
      this.query = '';
    }
    if (item.value === 'Range Wise Report') {
      this.$router.push('/report/range-wise-report/list');
      this.query = '';
    }
    if (item.value === 'Payments Report') {
      this.$router.push('/report/paymentReport/list');
      this.query = '';
    }
    if (item.value === 'Average Report') {
      this.$router.push('/report/averageReport/list');
      this.query = '';
    }
    if (item.value === 'Ledgers') {
      this.$router.push('/ledgers/list');
      this.query = '';
    }
    if (item.value === 'Admins') {
      this.$router.push('/admins/list');
      this.query = '';
    }
    if (item.value === 'Dealers') {
      this.$router.push('/dealers/list');
      this.query = '';
    }
    if (item.value === 'Products') {
      this.$router.push('/product/list');
      this.query = '';
    }
    if (item.value === 'Ranges') {
      this.$router.push('/ranges/list');
      this.query = '';
    }
    if (item.value === 'Branches') {
      this.$router.push('/branch/list');
      this.query = '';
    }
    if (item.value === 'Agents') {
      this.$router.push('/agents/list');
      this.query = '';
    }
    if (item.value === 'Orders') {
      this.$router.push('/order/list');
      this.query = '';
    }
    if (item.value === 'Dispatches') {
      this.$router.push('/orders-dispatches/list');
      this.query = '';
    }
  }
  async getAllTilesData() {
    if (AdminModule.userType === 'Admin') {
      this.fetchTotalOutstanding();
      this.getDealerCount();
      this.getProductCount();
      this.getAgentCount();
      this.fetchTotalCollection();
      this.fetchTotalFySales();
      this.fetchTotalFyPayment();
      this.fetchCurrentRecievable();
      this.fetchTotalPendingOrders();
      this.fetchCurrentMonthSales();
      this.fetchCurrentMonthPayments();
      this.fetchPreviousMonthPayments();
      this.fetchPreviousMonthSales();
      this.fetchSellingTopProducts();
      this.fetchTopDealers();
      this.fetchTotalAdvance();
      this.fetchPendingLedgers();
      this.fetchTotalAdvance();
      this.fetchTotalRangeWise();
      // this.fetchTotalStockValue()
    }
  }
  async fetchTotalAdvance() {
    const params = {
      applyBranchIdFilter: true,
      fromDashboard: true,
      advance: true,
      excludeBranches: this.excludeBranches
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    const data = await totalOutstanding(params);
    this.totalAdvanceAmount = data.totalBalance;
  }
  async fetchTotalRangeWise() {
    // Fetch active ranges if not loaded yet
    if (!this.rangeList.length) {
      try {
        const rangesData = await getRanges(getQuery({
          enabled: true,
          sort: 'name,ASC',
          filter: {
            enabled: '$eq'
          }
        }));
        const ranges = Array.isArray(rangesData) ? rangesData : rangesData.data || [];
        this.rangeList = ranges.map(r => ({
          id: r.id,
          name: r.name,
          key: r.name.toLowerCase().replace(/[^a-z0-9]/g, '_')
        }));
      } catch (error) {
        this.$message.error('Error Loading Ranges');
        return;
      }
    }
    try {
      const currentMonth = moment().month();
      const currentYear = moment().year();
      const isFinancialYearStart = currentMonth >= 3;
      const startYear = isFinancialYearStart ? currentYear : currentYear - 1;
      const endYear = startYear + 1;
      const params = {
        applyBranchIdFilter: true,
        fromDashboard: true,
        excludeBranches: this.excludeBranches,
        startDate: moment(`${startYear}-04-01 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm a'),
        endDate: moment(`${endYear}-03-31 23:59:59`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm a')
      };
      if (this.branchId) {
        params.branchId = this.branchId;
      }
      const data = await getRangeWiseReports(params);
      const allData = data.data || [];
      const totals = {};
      this.rangeList.forEach(r => {
        totals[r.key] = 0;
      });
      if (Array.isArray(allData)) {
        allData.forEach(item => {
          this.rangeList.forEach(r => {
            const val = parseFloat(item[r.key]);
            if (!isNaN(val)) totals[r.key] += val;
          });
        });
      }
      this.rangeTotals = {
        ...totals
      };
    } catch (error) {
      this.$message.error('Error Loading Range Wise Data');
    }
  }
  _isAdminRoles() {
    return isSuperAdmin() || isAdmin();
  }
  _isInvoiceManager() {
    return isInvoiceManager();
  }
  onCheckboxChange(value) {
    this.excludeBranches = value;
    this.getAllTilesData();
  }
  async handleFilter() {
    var _AdminModule$branchId;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.branchId = AdminModule.branchIds[0];
    }
    // if (!this._isAdminRoles()) {
    this.excludeBranches = true;
    // }
    if (this.branchId !== undefined) {
      await BranchAgentService.fetchBranches(this.branchId);
      // Fetch the list after agents and branches are loaded
      this.getAllTilesData();
    } else {
      // await this.handleClearBranch();
      this.getAllTilesData();
    }
  }
  async fetchTotalOutstanding() {
    const params = {
      applyBranchIdFilter: true,
      fromDashboard: true,
      excludeBranches: this.excludeBranches
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    const data = await totalOutstanding(params);
    this.totalOutstandingAmount = data.totalBalance;
  }
  async fetchPendingLedgers() {
    const params = {
      applyBranchIdFilter: true,
      isSuperAdmin: false
    };
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    if (isSuperAdmin()) {
      params.isSuperAdmin = true;
    }
    const data = await getPendingPaymentLedgerCount(params);
    this.totalPendingLedgers = data;
  }
  async fetchTotalCollection() {
    const params = {
      limit: 5,
      applyBranchIdFilter: true
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    const data = await totalCollection(params);
    this.totalAmountReceived = isNaN(+data.amountReceived) ? 0 : +data.amountReceived;
  }
  //  all sales related data from ledger table
  async fetchTotalFySales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentFinancialYearDate) {
      query.startDate = this.currentFinancialYearDate.start;
      query.endDate = this.currentFinancialYearDate.end;
    }
    const data = await totalFySales(query);
    this.totalFySales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  async fetchCurrentMonthSales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      fromDashboard: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentMonthDate) {
      query.startDate = this.currentMonthDate.start;
      query.endDate = this.currentMonthDate.end;
    }
    const data = await totalFySales(query);
    this.currentMonthSales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  async fetchPreviousMonthSales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      fromDashboard: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.previousMonthDate) {
      query.startDate = this.previousMonthDate.start;
      query.endDate = this.previousMonthDate.end;
    }
    const data = await totalFySales(query);
    this.previousMonthSales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  //  all sales related data from ledger table
  // all payment related data from transaction table
  async fetchTotalFyPayment() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentFinancialYearDate) {
      query.startDate = this.currentFinancialYearDate.start;
      query.endDate = this.currentFinancialYearDate.end;
    }
    const data = await totalFyPayment(query);
    this.totalFyPayment = isNaN(+data) ? 0 : +data;
  }
  async fetchCurrentMonthPayments() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentMonthDate) {
      query.startDate = this.currentMonthDate.start;
      query.endDate = this.currentMonthDate.end;
    }
    const data = await totalFyPayment(query);
    this.currentMonthPayments = isNaN(+data) ? 0 : +data;
  }
  async fetchPreviousMonthPayments() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.previousMonthDate) {
      query.startDate = this.previousMonthDate.start;
      query.endDate = this.previousMonthDate.end;
    }
    const data = await totalFyPayment(query);
    this.previousMonthPayments = isNaN(+data) ? 0 : +data;
  }
  // all payment related data from transaction table
  async fetchCurrentRecievable() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    const data = await totalCurrentRecievable(query);
    this.currentRecievableAmount = isNaN(+data.totalOutstanding) ? 0 : +data.totalOutstanding;
  }
  async fetchTotalPendingOrders() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    const data = await totalPendingOrders(query);
    this.totalPendingOrders = isNaN(+data) ? 0 : +data;
  }
  async fetchTotalStockValue() {
    try {
      const query = {
        enabled: true,
        page: 1,
        limit: 1000
      };
      if (this.branchId) {
        query.branchId = this.branchId;
      }
      const data = await getTotalStockValue(query);
      this.totalStockValue = data.totalStockValue;
    } catch (error) {
      this.totalStockValue = 0;
    }
  }
  async fetchOverdueByDays() {
    let params = {
      days: 30,
      dealerWise: false
    };
    const data30 = await getOverdueByDays(params);
    this.overdueAmount30days = +data30.overdueDealers[0].overdueAmount.toFixed(2);
    params = {
      days: 60,
      dealerWise: false
    };
    const data60 = await getOverdueByDays(params);
    this.overdueAmount60days = +data60.overdueDealers[0].overdueAmount.toFixed(2);
    params = {
      days: 90,
      dealerWise: false
    };
    const data90 = await getOverdueByDays(params);
    this.overdueAmount90days = +data90.overdueDealers[0].overdueAmount.toFixed(2);
    params = {
      days: 120,
      dealerWise: false
    };
    const data120 = await getOverdueByDays(params);
    this.overdueAmount120days = +data120.overdueDealers[0].overdueAmount.toFixed(2);
  }
  async fetchSellingTopProducts() {
    const params = {
      limit: 10,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (params.branchId) {
      params.branchId = this.branchId;
    }
    const data = await topSellingProducts(params);
    this.topProducts = data.data;
  }
  // need to verify
  async fetchTopDealers() {
    const params = {
      limit: 10,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    const data = await topDealers(params);
    this.topDealers = data.data;
  }
  async getSupportTicketCount() {
    this.supportTicketCount = await ordersTicketsCount({});
  }
  async getDealerCount() {
    try {
      // Build the query conditionally based on branchId
      const query = {
        enabled: true,
        branchId: undefined,
        applyBranchIdFilter: true,
        fromDealer: true
      };
      if (this.branchId) {
        query.branchId = this.branchId;
      }
      this.dealerCount = await dealersCount(getQuery(query));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getProductCount() {
    try {
      this.productscount = await productCount(getQuery({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getAgentCount() {
    // Build the query conditionally based on branchId
    const query = {
      enabled: true,
      branchId: undefined,
      applyBranchIdFilter: true
    };
    // Add branchId to query if it's defined
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    this.agentCount = await getAgentBranchWiseCount(getQuery(query));
  }
  getCurrentMonthDateRange() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    // Start date: first day of the current month at 12:00 AM
    const startDate = new Date(year, month, 1, 0, 0, 0);
    // End date: last day of the current month at 11:59 PM
    const endDate = new Date(year, month + 1, 0, 23, 59, 59);
    // Formatting the dates as "YYYY-MM-DD hh:mm AM/PM"
    const formatDate = date => {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };
      const dateStr = date.toLocaleString('en-US', options).replace(',', '');
      // Replace "/" with "-" in the date part
      return dateStr.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$1-$2');
    };
    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    };
  }
  generateReportLink() {
    const currentDateRange = this.getCurrentMonthDateRange();
    const startDate = currentDateRange.startDate;
    const endDate = currentDateRange.endDate;
    return `/report/salesReport/list?startDate=${startDate}&endDate=${endDate}`;
  }
  async dateval() {
    await this.fetchTotalFySales();
  }
  isSuperAdmin() {
    return AdminModule.roles.indexOf('Super Admin') > -1;
  }
  _isAdmin() {
    return isAdmin();
  }
  hasNoAccess(requiredRoles) {
    return isExcludedToAccess(requiredRoles);
  }
};
default_1 = __decorate([Component({
  name: 'PanelGroup',
  components: {
    CountTo,
    Inr
  }
})], default_1);
export default default_1;